/*global exports,require*/
var lib = require("./lib/serialijse");
exports.serialize = lib.serialize;
exports.deserialize = lib.deserialize;
exports.serializeZ = lib.serializeZ;
exports.deserializeZ = lib.deserializeZ;
exports.declarePersistable = lib.declarePersistable;



//////////////////
// WEBPACK FOOTER
// ./~/serialijse/index.js
// module id = 250
// module chunks = 1